import { TaskResponse } from "@9amhealth/openapi";

export const TaskStatus = TaskResponse.status;
export type TaskStatus = TaskResponse.status;
